<template>
    <main-layout id="installation-page">

        <app-header icon="factory">
            Installation
        </app-header>

        <nav id="actions-top" class="wrap" style="display: flex; justify-content: space-between">
            <action-bar :back="{name: 'liste-installations', params: { id: this.$route.params.id }}">
                <router-link v-if="typeUser === 'technicien'"
                             class="btn add btn-full"
                             id="main-action"
                             :to="{name: 'new-fibsdd', query: { detenteur: this.$route.params.id, installation: this.$route.params.idInst }}">
                    <i class="icon-add"></i>
                    <strong>Intervenir</strong> sur l'installation
                </router-link>
            </action-bar>
        </nav>

        <div class="wrap" v-if="installation.i_tag !== null || optionForceOtag === true">
            <router-link v-if="installation.fluide !== null" :to="{ name: 'information-installation' }" class="btn btn-full text-btn responsive-scop" style="background-color: #EA5E0B">Informations complémentaires <br> (DESP, Maintenance préventive, Attestation Entretien)</router-link>
            <router-link v-else :to="{ name: 'information-installation' }" class="btn btn-full text-btn responsive-scop" style="background-color: #EA5E0B">Informations complémentaires <br> (Maintenance préventive)</router-link>
        </div>

        <div id="map" ref="map" class="hide" style="height: 210px; width: 100%; margin-bottom: 10px"></div>


        <form method="post" class="wrap" id="installation" @submit.prevent="sendForm">
            <input type="hidden" name="idInstall">



            <div v-if="installation.i_tag !== null" style="display: flex; justify-content: space-between; align-content: center; align-items: center">
                <label style="flex-basis: content">OTAG INSTALL</label>
                <input style="flex-basis: content" title="installItag" type="text" name="itag" v-model.trim="installation.i_tag" maxlength="255" readonly>
                <a  :href="`fi360://scan?success=tryGoToInstall&idInst=` + this.$route.params.idInst + `&idDet=` + this.$route.params.id" class="btn btn-full text-btn" id="change-itag" style="background-color: rgb(234, 94, 11); flex-basis: content; padding-right: 20px">Changer l'otag install</a>
            </div>
            <div v-else>
                <a :href="`fi360://scan?success=tryGoToInstall&idInst=` + this.$route.params.idInst + `&idDet=` + this.$route.params.id" class="btn btn-full text-btn" id="add-itag" style="background-color: rgb(234, 94, 11);">Ajouter une otag install</a>
            </div>


            <label>Nom de l'installation *</label>
            <div style="display: flex;">
                <input title="installName" type="text" name="nom" id="nom" maxlength="255" value="" v-model.trim="installation.nom">
                <a v-if="optionBarcode === true" href="fi360://scan?success=fillCodeBarre&type=installation" class="btn btn-full" id="barcode-scan" style="margin-left: 5px"><img src="../../img/barcode-scan.png" style="padding: 0 20px; height: 35px"> </a>
            </div>

            <label>Marque <span v-if="!gotFluide">*</span></label>
            <input title="marque" type="text" name="nom" id="marque" value="" v-model.trim="installation.marque" maxlength="255">

            <label>Modèle / N° de série / Repère <span v-if="!gotFluide">*</span></label>
            <input title="model" type="text" name="nom" id="modele" value="" v-model.trim="installation.modele" maxlength="255">

            <label>Commentaire</label>
            <input title="commentaire" type="text" name="commentaire" id="commentaire" value="" v-model.trim="installation.commentaire" maxlength="255">

            <div v-for="slot in photoSlots" :key="slot.field">
                <a href="javascript: void 0" class="btn btn-full photo" @click="$refs['photo_' + slot.field][0].click()">
                    {{ slot.label }}
                    <i class="icon-photo"></i>
                </a>
                <input type="file" :ref="'photo_' + slot.field" v-show="false" @change="handlePhotoInstall($event, slot.field)">
                <div v-if="getUrlPhoto(slot.field) !== null" class="preview-img">
                    <i class="icon icon-delete" @click="dropPhoto(slot.field)"></i>
                    <a :href="getUrlPhoto(slot.field)" title="photo de l'installation" target="_blank">
                        <img :src="getUrlPhoto(slot.field)" alt="photo installation" class="photo-install">
                    </a>
                </div>
            </div>

            <div v-if="gotFluide">

                <!--
                <label>Puissance Électrique (kW)</label>
                <input title="puissanceElectrique" type="number" name="puissance_electrique" min="0.010" step="0.001" id="puissance_electrique" v-model.number="installation.puissance_electrique">

                <label>Puissance Calorifique (kW)</label>
                <input title="puissanceCalorifique" type="number" name="puissance_calorifique" min="0.010" step="0.001" id="puissance_calorifique" v-model.number="installation.puissance_calorifique">

                <label>Puissance Frigorifique (kW)</label>
                <input title="puissanceFrigorifique" type="number" name="puissance_frigorifique" min="0.010" step="0.001" id="puissance_frigorifique" v-model.number="installation.puissance_frigorifique">
                -->


                <label>Type de fluide *</label>
                <select v-if="installation.fluide"
                        v-model="installation.fluide" @change="updateComputed">
                    <option selected disabled>Sélectionnez un fluide *</option>
                    <option v-for="fluide in fluides" :key="fluide.id" :value="fluide">{{ fluide.nom }}{{
                            (fluide.nom_commercial) ? ' - ' + fluide.nom_commercial : ''}}
                    </option>
                </select>

                <label>Charge totale (Kg) *</label>
                <input title="chargeTotal" type="number" name="charge_totale" min="0.010" step="0.001" id="charge_totale"
                       v-model.number="installation.charge" @change="updateComputed">

                <label>Détecteur de fuite fixe *</label>
                <div class="radio">
                    <input name="detecteur_fuite_fixe" id="fuite_ok" type="radio" :value="true"
                           v-model="installation.detecteur" @change="updateComputed">
                    <label for="fuite_ok" class="custom-radio">
                        Oui
                        <i class="icon-valid"></i>
                    </label>
                </div>

                <div class="radio">
                    <input name="detecteur_fuite_fixe" id="fuite_ko" type="radio" :value="false"
                           v-model="installation.detecteur" @change="updateComputed">
                    <label for="fuite_ko" class="custom-radio">
                        Non
                        <i class="icon-valid"></i>
                    </label>
                </div>

                <div class="clear"></div>

                <div v-if="canForceFrequence === true">
                    <label>Fréquence de contrôle forcée</label>
                    <div class="radio">
                        <input name="force_frequence" id="force_frequence" type="radio" :value="true"
                               v-model="installation.force_frequence" @change="updateComputed">
                        <label for="force_frequence" class="custom-radio">
                            Oui
                            <i class="icon-valid"></i>
                        </label>
                    </div>

                    <div class="radio">
                        <input name="force_frequence" id="force_frequence_no" type="radio" :value="false"
                               v-model="installation.force_frequence" @change="updateComputed">
                        <label for="force_frequence_no" class="custom-radio">
                            Non
                            <i class="icon-valid"></i>
                        </label>
                    </div>
                </div>

                <div class="clear"></div>

                <div v-if="installation.force_frequence === true">
                    <label>Fréquence de contrôle</label>
                    <select name="frequence_controle" id="frequence_controle" v-model="installation.frequence_controle">
                        <option value="3">3 mois</option>
                        <option value="6">6 mois</option>
                        <option value="12">12 mois</option>
                        <option value="24">24 mois</option>
                    </select>
                </div>

                <div v-show="fluideIsFibsdd">
                    <p v-if="installation.fluide !== null && installation.fluide.type !== 'HFO'">
                        Tonnage équivalent CO<span class="smallexp">2</span> :
                        <span id="tonnage" v-text="installation.tonnage"></span>
                    </p>

                    <p>
                        GWP :
                        <span id="gwp" v-text="installation.fluide.gwp"></span>
                    </p>

                    <p v-if="installation.fluide && installation.fluide.type !== 'CFC'">
                        Fréquence de contrôle <span v-if="installation.force_frequence === true" style="font-weight: bold;">forcée</span> de l'installation :
                        <span id="frequence">{{ installation.frequence_controle === 0 || installation.frequence_controle == null ? 'Aucune' : installation.frequence_controle + ' Mois' }}</span>
                    </p>

                    <p v-if="installation.file_notice && installation.file_notice !== null">
                        Notice de l'installation : <a target="_blank" style="width: 25%; margin-left: 10px; display: inline-flex" class="btn-full btn photo" :href="getUrlNotice"><i class="fas fa-file-alt"></i> Voir</a>
                    </p>

                    <p v-if="installation.last_control != null">
                        Date du dernier contrôle périodique :
                        <span id="dateLastControl">{{ installation.last_control|dateFormat('DD/MM/YYYY') }}</span>
                    </p>
                </div>

            </div>

            <input type="submit" id="submit-install" name="new" v-if="canEditInstallations" value="SAUVEGARDER">

        </form>

        <section v-if="fis.length !== 0" style="padding: 0 10px;">
            <hr>
            <h2><strong>REGISTRE DES INTERVENTIONS</strong></h2> <br>
            <ul class="interventions-list" style="padding-bottom: 20px">
                <li class="intervention-item" v-for="fi in fis.slice().reverse()" :key="fi.id">
                    <template v-if="fi.isFibsdd === true">
                        {{ fi.dateToShow }} -
                        <a :href="`${Config.urlAdmin}/pdf/fiche/${fi.id}?token=${token}`" target="_blank">
                            {{ fi.numero }}
                        </a>
                        <small v-if="fi.intervention_controle_p === true"> - Contrôle périodique </small>
                    </template>
                    <template v-else>
                        {{ fi.dateToShow }} -
                        <a :href="`${Config.urlAdmin}/pdf/externalFile/${fi.id}?token=${token}`" target="_blank">
                            {{ fi.name }}
                        </a>
                    </template>
                </li>
            </ul>
        </section>

    </main-layout>
</template>

<script>
import Api from '../../js/core/Api';
import Installation from '../../js/models/Installation'
import Fluide from '../../js/models/Fluide'
import Config from '../../js/config'

import loadImage from 'blueimp-load-image'
import Operateur from "../../js/models/Operateur";
import Scan from "../../js/models/Scan";
import {install} from "offline-plugin/runtime";

export default {
    data() {
        return {
            typeUser: localStorage.getItem('typeUser'),
            installation: {
            },
            photoSlots: [
                {field: 'photo', label: 'PHOTO INSTALLATION 1'},
                {field: 'photo2', label: 'PHOTO INSTALLATION 2'},
                {field: 'photo3', label: 'PHOTO INSTALLATION 3'},
            ],
            fluides: null,
            canEditInstallations: null,
            fis: [],
            token: null,
            urlNotice: null,
            canForceFrequence: false,
            optionBarcode: false,
            optionForceOtag: false
        }
    },

    computed: {
        Config() {
            return Config
        },

        gotFluide() {
            return (!_.isEmpty(this.installation.fluide));
        },

        getUrlNotice() {
            if(this.installation.file_notice != null) {
                return `${Config.urlAdmin}/pdf/installation/notice/${this.installation.id}?token=${this.token}`;
            }
            return null;
        },

        fluideIsFibsdd(){
            if(!_.isEmpty(this.installation.fluide)){
                const typeFluide = this.installation.fluide.type;
                return (
                    typeFluide === 'HFC' ||
                    typeFluide === 'HCFC' ||
                    typeFluide === 'CFC' ||
                    typeFluide === 'Mélange HFO/HFC' ||
                    typeFluide === 'HFO'
                );
            } else {
                return false
            }
        }
    },

    methods: {
        install,

        sendForm() {

            let installation = this.installation;
            let errors = [];

            // CONDITION COMMUNE
            if (!installation.nom) {
                errors.push("le nom de l'installation")
            }

            if (_.isEmpty(installation.fluide)) {

                if (!installation.marque) {
                    errors.push("la marque")
                }
                if (!installation.modele) {
                    errors.push("le modèle")
                }

            } else {

                if (_.isEmpty(installation.fluide)) {
                    errors.push("le fluide")
                }
                if (!installation.charge) {
                    errors.push("la charge")
                }
                if (installation.detecteur === null) {
                    errors.push("le détecteur")
                }

            }

            if (errors.length !== 0) {

                let txt = errors.join(', ');
                swal('Information(s) manquante(s) :', 'Veuillez renseigner ' + txt + '.', 'error')

            } else {

                if(this.$route.query.itag != null){
                    Scan.addOfflineScanInstallation(this.installation.id);
                }

                Installation
                    .updateInstallation(this.installation)
                    .then(() => {
                        this.$router.push({name: 'liste-installations', params: {id: this.$route.params.id} })
                    })
                    .catch(() => {
                        swal('Erreur', "L'installation n'a pas pu être enregistrée", 'error')
                    })

            }

        },

        getUrlPhoto(field) {
            const photo = this.installation[field];

            if (photo === null || typeof photo == "undefined" || photo === '') { return null }

            // certains enregistrements en cache portent déjà une URL complète :
            // les re-préfixer produirait ".../upload https://.../upload/..."
            if (_.includes(photo, ';base64') || _.startsWith(photo, 'http')) { return photo }

            return Config.urlAPI + '/upload' + photo;
        },

        handlePhotoInstall(e, field) {
            let vueInstance = this;
            let input = e.target;
            let file = input.files[0];

            if (!file) { return }

            // réinitialisé avant traitement : permet de re-sélectionner le même
            // fichier après suppression, y compris si loadImage échoue
            input.value = null;

            loadImage(
                file,
                function (img) {
                    if (img instanceof Event) {
                        swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier.', 'error');
                        return;
                    }
                    vueInstance.$set(vueInstance.installation, field, img.toDataURL('image/jpeg', 0.82));
                },
                {
                    maxWidth: 700,
                    maxHeight: 700,
                    orientation: true,
                    canvas: true
                }
            )
        },

        dropPhoto(field) {
            this.$set(this.installation, field, null);
        },

        fetchFluides() {
            let vueInstance = this;

            localforage.getItem('listFluides')
                .then(fluides => {
                    fluides = JSON.parse(fluides);
                    vueInstance.fluides = fluides.noFiltre.filter(f => !f.regenerated);
                })
                .catch()
        },

        fetchInstall() {

            return new Promise((resolve, reject) => {
                let vueInstance = this;
                let idInstall = this.$route.params.idInst;
                let itag = this.$route.query.itag;

                Installation
                    .getInstallation(idInstall)
                    .then(res => {
                        if(res.fluide !== null) {
                            res.charge = round(res.charge, 3);
                            res.tonnage = Fluide.calcTonnage(res.fluide, res.charge);
                            // La fréquence en base peut venir d'un ancien calcul : l'enregistrement la corrige.
                            if (res.force_frequence !== true) {
                                res.frequence_controle = Installation.calcFrequence(res.detecteur, res.tonnage, res.charge, res.fluide);
                            }
                        }
                        // Les installations mises en cache avant l'ajout du commentaire n'ont pas
                        // la clé : sans elle, Vue 2 ne rend pas le champ réactif au v-model.
                        if (!('commentaire' in res)) {
                            res.commentaire = null;
                        }
                        vueInstance.installation = res;
                        if(typeof itag !== "undefined") {
                            vueInstance.installation.i_tag = itag;
                        }
                        return resolve(true)
                    })
                    .catch(() => {
                        reject(false)
                    })
            })


        },

        async fetchFis() {
            let api = await Api.init();
            api
                .get(`installation/${this.installation.id}/fibsdds/1`)
                .then(res => {
                    if (typeof res.data.fis !== "undefined") {
                        res.data.fis.forEach(data => {
                            if (data.isFibsdd) {
                                data.dateToShow = data.dateToShow || "En cours";
                            }
                            this.fis.push(data);
                        });
                    }
                }).then(() => {
                    this.fis = _.sortBy(this.fis, f => {
                        return new Date(f.dateToShow.split('/').reverse().join('-'));
                    })
                })
                .catch()

        },

        updateComputed() {

            if (_.has(this.installation.fluide, 'gwp') && this.installation.charge != null) {

                this.updateTonnage();

                if (this.installation.detecteur !== null && this.installation.force_frequence !== true) {
                    this.updateFrequence()
                }

            }

        },

        updateTonnage() {
            this.installation.tonnage = Fluide.calcTonnage(this.installation.fluide, this.installation.charge);
        },

        updateFrequence() {
            this.installation.frequence_controle = Installation.calcFrequence(
                this.installation.detecteur,
                this.installation.tonnage,
                this.installation.charge,
                this.installation.fluide
            );
        },

        displayMap() {

            if(this.installation.i_tag != null) {
                let lastScan = _.last(this.installation.scans_installations);


                if(typeof lastScan !== "undefined") {

                    let mapEl = document.getElementById('map');

                    mapEl.classList.remove('hide');

                    let map = L.map(mapEl, { attributionControl : false, center: [lastScan.lat, lastScan.lng], zoom: 19, maxZoom: 19, zoomControl: false });
                    delete L.Icon.Default.prototype._getIconUrl;
                    L.Icon.Default.mergeOptions({
                        iconRetinaUrl: "https://admin.fi360.fr/img/marker-orange.png",
                        iconUrl: "https://admin.fi360.fr/img/marker-orange.png",
                        shadowUrl: require("leaflet/dist/images/marker-shadow.png")
                    });

                    let layer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        maxZoom: 19,
                    });

                    map.addLayer(layer);

                    let marker = L.marker([lastScan.lat, lastScan.lng], {
                    }).addTo(map);

                    marker.bindPopup(`<b>${this.installation.nom}</b><br>${moment(lastScan.created_at).format('DD/MM/YYYY HH:mm')}`, {
                      className: 'custom-popup'
                    })

                }
            }

        }
    },

    mounted: function () {
        this.canEditInstallations = JSON.parse(localStorage.getItem('canEditInstallations'));
        localforage.getItem('api-token').then(token => this.token = token).catch();
        this.fetchFluides();



        this.fetchInstall().then(() => {
            if(this.$route.query.scan != null){
              Scan.addOfflineScanInstallation(this.installation.id);
            }
            this.fetchFis()
        }).then(() => {
            this.$nextTick(() => {
                this.displayMap(); // Appel de la fonction displayMap lors du montage du composant
            });
        })

        Operateur.getOperateurOption(options => {
            this.canForceFrequence = options.includes('force_install_frequence');
            this.optionBarcode = options.includes('scan_barcode_install');
            this.optionForceOtag = options.includes('force_otag_install');
        })

    },
}
</script>

<style>

@import '~leaflet/dist/leaflet.css';

/* Style de la liste des interventions */
.interventions-list {
    list-style: none;
    padding: 0;
}

/* Style des éléments de la liste d'interventions */
.intervention-item {
    margin-bottom: 10px;
    padding: 5px;
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// Installation.vue?6729b104